// dot-prop-immutable
import dotProp from 'dot-prop-immutable';

class MyLocalStorage {
    init(value, setLocalStorageState, resetLocalStorageState) {
        this.value = value;
        this.setLocalStorageState = setLocalStorageState;
        this.resetLocalStorageState = resetLocalStorageState;
    }

    resetState(path) {
        if (typeof path === 'string') {
            this.setLocalStorageState((prevState) => {
                let defaultValue = dotProp.get(LocalStorageDefault, path);
                return dotProp.set(prevState, path, defaultValue);
            });
        } else {
            this.resetLocalStorageState();
        }
    }

    setState(path, object) {
        if (typeof path === 'string') {
            this.setLocalStorageState((prevState) => {
                return dotProp.set(prevState, path, object);
            });
        } else {
            this.setLocalStorageState((prevState) => {
                for (let key of Object.keys(path)) {
                    prevState = dotProp.set(prevState, key, path[key]);
                }
                return prevState;
            });
        }
    }

    getValue(path) {
        if (typeof path === 'string') {
            return dotProp.get(this.value, path);
        } else {
            return this.value;
        }
    }
}

const appLocalStorage = new MyLocalStorage();

export { appLocalStorage as localStorage };
